<template>
  <div style="padding: 1rem; background: #fff">
    <FileTable
      ref="fileTableRef"
      :attachments="storageAttachment"
      :isDisabledDelete="operateType === 'detail' || operateType === 'audit'"
      :isDisabledUpload="operateType === 'detail' || operateType === 'audit'"
      :isShowDownBtn="operateType === 'detail' || operateType === 'audit'"
    />
  </div>
</template>

<script>
  export default {
    name: 'contractAttachment',
    props: ['detailAttachTableData'],
    computed: {
      operateType() {
        return this.$route.query.type;
      },
    },
    data() {
      return {
        storageAttachment: [],
      };
    },
    watch: {
      detailAttachTableData(newVal) {
        if (newVal) {
          this.storageAttachment = newVal;
        }
      },
    },
    // this.storageAttachment = this.$refs.fileTableRef.getTableData();
  };
</script>

<style lang="scss" scoped>
  .title {
    font-size: 20px;
    font-weight: 600;
  }
</style>
